import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../BaseUrlConfigration/ApiConfig";

export const getAllPacksAction = createAsyncThunk(
  "pack/list",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.get(
        `school/packs/fetch-videoPacks?search=${reqBody?.searchValue}`
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getPackDetailsAction = createAsyncThunk(
  "pack/details",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.get(`school/packs/details/${reqBody}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const requestAccessAction = createAsyncThunk(
  "request/access",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.post(`school/packs/request-access`, reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getRequestedPacksAction = createAsyncThunk(
  "requested/packs",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.get(
        `school/packs/requested-packs?search=${reqBody?.searchValue}`
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
